import { render } from "./InformationListDrop.vue?vue&type=template&id=5b794900&scoped=true"
import script from "./InformationListDrop.vue?vue&type=script&lang=js"
export * from "./InformationListDrop.vue?vue&type=script&lang=js"

import "./InformationListDrop.vue?vue&type=style&index=0&id=5b794900&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b794900"]])

export default __exports__